import classNames from 'classnames';
import React, { FC } from 'react';

import { Incomplete, InProgress, Success, Warning } from 'src/Icons';
import { StatusLabelClassNames, StatusLabelStatus } from 'src/types';

export interface StatusIconProps {
  className?: string;
  status: `${StatusLabelStatus}`;
}

export const StatusIcon: FC<StatusIconProps> = ({ className, status }) => {
  switch (status) {
    case StatusLabelStatus.INCOMPLETE:
      return <Incomplete className={classNames(className, StatusLabelClassNames.INCOMPLETE)} />;

    case StatusLabelStatus.IN_PROGRESS:
      return <InProgress className={classNames(className, StatusLabelClassNames.IN_PROGRESS)} />;

    case StatusLabelStatus.SUCCESS:
      return <Success className={classNames(className, StatusLabelClassNames.SUCCESS)} />;

    case StatusLabelStatus.WARNING:
      return <Warning className={classNames(className, StatusLabelClassNames.WARNING)} />;

    default:
      return null;
  }
};
